import { Component, Input } from '@angular/core';
import { AbstractDialogComponent } from '../../../../Core/Dialogs/components/AbstractDialog/abstract-dialog.component';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { ButtonTypesEnum } from '../../../../Common/Forms/enums/button-types.enum';


@Component({
    selector: 'agpr-bulk-action-confirmation-dialog.component',
    templateUrl: './bulk-action-confirmation-dialog.component.html',
    styleUrls: ['./bulk-action-confirmation-dialog.component.scss'],
    standalone: false
})
export class BulkActionConfirmationDialogComponent extends AbstractDialogComponent {
    readonly buttonTypes = ButtonTypesEnum;
    public readonly messageSeverityEnum = messageSeverityEnum;
    @Input() dialogHeading: string = 'Common.bulkActionConfirmation.confirmAction';

    @Input() id: string;
    @Input() message: string;
    @Input() messageParameters: { [key: string]: string };
    @Input() itemCount: number;
    @Input() itemCountLabel: string;
    @Input() okLabel: string;
    @Input() cancelLabel: string = 'Core.button.cancel';
    @Input() showTimeWarning: boolean = true;

    constructor(public coreDialogService: CoreDialogService) {
        super(coreDialogService, 'BulkActionConfirmation');
    }

    /**
     * Action when the user clicks the "OK" button
     */
    ok(): void {
        this.closeDialog(true);
    }

    /**
     * Action when the user clicks the "Cancel" button, or closes the dialog via the "X" in the header
     */
    cancel(): void {
        this.closeDialog(false);
    }

}
